export default __webpack_public_path__ + "media/images/tenant/howToRentApartment/step_1-4753e38efbc4de05830f7fb8b45842d1.jpg";